module.exports = __webpack_public_path__ + "media/images/icons/material/handshake-full-70d8d14767c624a8155035cc68a206d6.svg";